
import axios from "axios";

export const GET_PROFILE = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(`${process.env.REACT_APP_API_HOST}/my_profile`)
        .then(
          (response) => {
            resolve(response.data); // Resolve with the data from the response
          })
        .catch((err) => {
          reject(err); // Reject with the error
        });
    } catch (error) {
      reject(error); // If there's an error in the try block, reject the Promise
    }
  });
};
  

  export const UPDATE_PROFILE = (payload) => {
    return new Promise((resolve, reject) => {
      try {
        axios
          .put(`${process.env.REACT_APP_API_HOST}/my_profile`,payload)
          .then(
            (response) => {
              resolve(response.data); // Resolve with the data from the response
            })
          .catch((err) => {
            reject(err); // Reject with the error
          });
      } catch (error) {
        reject(error); // If there's an error in the try block, reject the Promise
      }
    });
  };